module.exports = __webpack_public_path__ + "img/guest-star.59a697c3.svg";